// @flow
import type { Thunk, Dispatch } from 'types/redux';
import type { State as StoreState } from 'store/State';

// Constants
import { GA_EVENTS } from 'constants/ga';

// Selectors
import {
  getUniversalAnalytics,
  getAsburyGAIDs
} from 'store/reducers/dealerData/selectors';

/* eslint-disable camelcase */
export const gaClickTrackingEvent = (event: string): Thunk<void> => (
  dispatch,
  getState
) => {
  const universalAnalytics = getUniversalAnalytics(getState());
  universalAnalytics.forEach(({ trackingId, trackerName }) => {
    const isGA4id = isGA4(trackingId);
    if (!isGA4id && trackingId && trackerName && window.ga) {
      window.ga(`${trackerName}.send`, 'event', 'Xtime', event, {
        nonInteraction: true
      });
      return null;
    }
    if (isGA4id && trackingId && trackerName && window.gtag) {
      window.gtag('event', 'asc_cta_interaction', {
        send_to: trackingId,
        event_owner: 'Xtime',
        event_action: event
      });
      if (event === GA_EVENTS.CONFIRM) {
        sendAscSubmissionEvent('asc_form_submission', trackingId);
        sendAscSubmissionEvent('asc_form_submission_service_appt', trackingId);
      }
      return null;
    }
  });
};

const sendAscSubmissionEvent = (event, trackingId) => {
  window.gtag('event', event, {
    send_to: trackingId,
    event_owner: 'Xtime',
    element_text: 'Book it',
    form_type: 'confirm',
    form_name: 'confirm'
  });
};

export const gaCreateTrackers = () => async (
  dispatch: Dispatch,
  getState: () => StoreState
) => {
  const universalAnalytics = getUniversalAnalytics(getState());
  universalAnalytics.forEach(({ trackingId, trackerName }) => {
    const isGA4id = isGA4(trackingId);
    if (!isGA4id && trackingId && trackerName && window.ga) {
      window.ga('create', trackingId, 'auto', trackerName);
      window.ga(`${trackerName}.set`, 'referrer', window.referrerTopURL);
      return null;
    }
    if (isGA4id && trackingId && trackerName && window.gtag) {
      window.gtag('set', 'page_referrer', window.referrerTopURL);
      window.gtag('config', trackingId, {
        cookie_flags: 'secure;samesite=none'
      });
      return null;
    }
  });
};

export const gaCreateAsburyTrackers = () => async (
  dispatch: Dispatch,
  getState: () => StoreState
) => {
  const gaIDs = getAsburyGAIDs(getState());
  let i = 0;
  if (!gaIDs) {
    return null;
  }
  for (i; i < gaIDs.length; i++) {
    const isGA4id = isGA4(gaIDs[i]);
    if (!isGA4id && gaIDs[i] && window.ga) {
      window.ga('create', gaIDs[i], 'auto', `Asbury_GA_${i}`);
    }
    if (isGA4id && gaIDs[i] && window.gtag) {
      window.gtag('set', 'page_referrer', window.referrerTopURL);
      window.gtag('config', gaIDs[i], {
        cookie_flags: 'max-age=7200;secure;samesite=none'
      });
    }
  }
};

export const gaAsburyEvents = (
  eventAction: string,
  eventLabel: string,
  ConfirmationId: string
) => async (dispatch: Dispatch, getState: () => StoreState) => {
  const gaIDs = getAsburyGAIDs(getState());
  let i = 0;
  if (!gaIDs) {
    return null;
  }
  for (i; i < gaIDs.length; i++) {
    const isGA4id = isGA4(gaIDs[i]);
    if (!isGA4id && gaIDs[i] && window.ga) {
      window.ga(`Asbury_GA_${i}.set`, 'referrer', window.referrerTopURL);
      window.ga(`Asbury_GA_${i}.send`, {
        hitType: 'event',
        eventCategory: 'Xtime',
        eventAction,
        eventLabel,
        dimension1: ConfirmationId,
        nonInteraction: true
      });
    }
    if (isGA4id && gaIDs[i] && window.gtag) {
      window.gtag('event', 'asc_cta_interaction', {
        send_to: gaIDs[i],
        event_action: eventAction,
        event_action_result: eventLabel,
        submission_id: ConfirmationId
      });
    }
  }
};

const isGA4 = id => {
  return id && id.indexOf('UA-') < 0;
};
/* eslint-enable camelcase */



// WEBPACK FOOTER //
// ./src/store/reducers/ga/actions.js